import React from 'react';
import { Constants } from '../../Constants';

export function ConsigneeDetails(){
    return (
        <div className="row">
            <div className="col-12"><hr/></div>
            <div className="col-12">
                <strong>Finally, please provide the consignee's details: </strong><br />
                <em>Consignee is the person or Company receiving the cargo at the port of destination. 
                     Consignee's address cannot be a P.O. box</em>
            </div>
            <div className="col-sm-12 col-md-6 mt-2">
                <div className="card border border-dark p-2">
                    <div className="display-5 mb-2">Consignee details</div>
                    <div className="row">
                        <div className="col-md-12 col-sm-9">
                            <label asp-for="Consignee.FullName" className="control-label">Full Name</label>                
                            <input required name="Consignee.FullName" className="form-control" autoComplete="off"/>
                            <span asp-validation-for="Consignee.FullName" className="text-danger"></span>
                        </div>
                        <div className="col-md-6 col-sm-8 mt-sm-2">
                            <label asp-for="Consignee.emailAddress" className="control-label">Email Address</label>
                            <input name="Consignee.emailAddress" className="form-control" autoComplete="off"/>
                            <span asp-validation-for="Consignee.emailAddress" className="text-danger"></span>
                        </div>
                        <div className="col-md-6 col-sm-8 mt-sm-2">
                            <label asp-for="Consignee.phoneNumber" className="control-label">Phone Number</label>
                            <input required name="Consignee.phoneNumber" className="form-control" autoComplete="off"/>
                            <span asp-validation-for="Consignee.phoneNumber" className="text-danger"></span>        
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-sm-12 col-md-6 mt-2">
                <div className="card border border-dark p-2">
                    <div className="display-5 mb-2">Consignee Address</div>
                    <div className="row">
                        <div className="col-md-12 col-sm-9">
                            <label asp-for="ConsigneeAddress.streetAddress" className="control-label">Street Address</label>
                            <input required name="ConsigneeAddress.streetAddress" className="form-control" autoComplete="off"/>
                            <span asp-validation-for="ConsigneeAddress.streetAddress" className="text-danger"></span>
                        </div>
                        <div className="col-md-6 col-sm-9 mt-sm-2">
                            <label asp-for="ConsigneeAddress.City" className="control-label">City</label>
                            <input required name="ConsigneeAddress.City" className="form-control" autoComplete="off"/>
                            <span asp-validation-for="ConsigneeAddress.City" className="text-danger"></span>
                        </div>
                        <div className="col-md-6 col-sm-8 mt-sm-2">
                            <label asp-for="ConsigneeAddress.State" className="control-label">State</label>
                            <input required name="ConsigneeAddress.State" className="form-control" autoComplete="off"/>
                            <span asp-validation-for="ConsigneeAddress.State" className="text-danger"></span>
                        </div>
                        <div className="col-md-6 mt-sm-2">
                            <label asp-for="ConsigneeAddress.ZIPCode" className="control-label">ZIP Code</label>
                            <input name="ConsigneeAddress.ZIPCode" className="form-control" autoComplete="off"/>
                            <span asp-validation-for="ConsigneeAddress.ZIPCode" className="text-danger"></span>        
                        </div>
                        <div className="col-md-6 col-sm-8 mt-sm-2">
                            <label asp-for="ConsigneeAddress.Country" className="control-label">Country</label>
                            <select required name="ConsigneeAddress.Country" className="form-select" autoComplete="off">
                                {Constants.worldCountriesList.map((val,index) => 
                                    <option key={index} value={val}>{val}</option>
                                )}
                            </select>
                            <span asp-validation-for="ConsigneeAddress.Country" className="text-danger"></span>        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}